module.exports = __webpack_public_path__ + "static/img/gl4.42118b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/gl4.png
// module id = 7pET
// module chunks = 3